/*
  PDP custom buy buttons (toggle in buy_buttons block).

  1. "Buy now" button: adds the currently-selected variant + quantity (and the
     selected Loop selling plan, if any) to the cart, then redirects to /checkout
     — same end result as the checkout button. It is type="button" so the theme's
     <product-form> add-to-cart handler never intercepts it.

  2. Price sync — two sources, in priority order:
     a. Loop subscription widget (when present): the shopper toggles One-time vs
        Subscribe & Save (and frequency), and Loop shows the effective price inside
        its OWN DOM. We mirror the *selected* option's price into both buttons and
        re-run under a MutationObserver, because Loop re-renders itself (same reason
        loop-widget-usp.js observes). This also feeds the selling_plan into Buy now.
     b. Variant change (no Loop): the theme re-fetches the section and publishes
        PUB_SUB_EVENTS.variantChange with the fetched `html`; we copy the refreshed
        "— price" spans out of it and mirror the Add-to-cart disabled state.
*/
(function () {
  var CHECKOUT_URL = '/checkout';
  var LOOP_SELECTED =
    '.loop-widget-purchase-options-container .loop-widget-purchase-option-selected, ' +
    '.loop-widget-purchase-options-container [aria-checked="true"]';

  function addUrl() {
    return (
      (window.theme && theme.routes && theme.routes.cart_add_url) ||
      (window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root + 'cart/add'
        : '/cart/add')
    );
  }

  function priceSpans() {
    return document.querySelectorAll('.pdp-atc--custom .pdp-btn__price, .pdp-buy-now .pdp-btn__price');
  }

  // The Loop option the shopper currently has selected (one-time or a plan group).
  function selectedLoopOption() {
    return document.querySelector(LOOP_SELECTED);
  }

  // selling_plan id for the selected Loop option (null for one-time / no widget).
  function selectedSellingPlan(form) {
    var opt = selectedLoopOption();
    if (opt) {
      if (opt.hasAttribute('data-loop-widget-onetime-purchase-option')) return null;
      var sel = opt.querySelector('select[name="selling_plan"]');
      if (sel && sel.value) return sel.value;
    }
    // Fallback: a selling_plan field inside the product form itself.
    var formSel = form && form.querySelector('[name="selling_plan"]');
    return formSel && formSel.value ? formSel.value : null;
  }

  // Copy the selected Loop option's displayed price into both buttons.
  function syncLoopPrice() {
    var opt = selectedLoopOption();
    if (!opt) return false;
    var priceEl = opt.querySelector('.loop-widget-purchase-option-price');
    var text = priceEl && priceEl.textContent ? priceEl.textContent.trim() : '';
    if (!text) return false;
    priceSpans().forEach(function (span) {
      // Only write when the value actually changes. Writing textContent mutates a
      // node inside the observed subtree, so an unconditional write would re-trigger
      // our own MutationObserver every frame (infinite pdp-btn__price replacement).
      if (span.textContent !== text) {
        span.textContent = text;
      }
    });
    return true;
  }

  function buyNow(btn) {
    if (btn.disabled || btn.classList.contains('loading')) return;

    var form = btn.closest('form') || btn.closest('product-form');
    if (form && form.tagName === 'PRODUCT-FORM') form = form.querySelector('form');
    if (!form) return;

    var idInput = form.querySelector('.product-variant-id') || form.querySelector('[name="id"]');
    var id = idInput && idInput.value;
    if (!id) return;

    var qtyInput = form.querySelector('[name="quantity"]');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    var item = { id: Number(id), quantity: quantity };
    var plan = selectedSellingPlan(form);
    if (plan) item.selling_plan = Number(plan) || plan;

    btn.classList.add('loading');
    btn.setAttribute('aria-busy', 'true');

    fetch(addUrl() + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed (' + res.status + ')');
        window.location.href = CHECKOUT_URL;
      })
      .catch(function (err) {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-busy');
        console.error('[pdp-buy-now]', err);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pdp-buy-now]');
    if (!btn) return;
    e.preventDefault();
    buyNow(btn);
  });

  // Keep button prices + Buy-now disabled state in sync on variant change.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.html) return;
      var sectionId = data.sectionId;

      ['AtcButtonPrice', 'BuyNowButtonPrice'].forEach(function (base) {
        var dest = document.getElementById(base + '-' + sectionId);
        if (!dest) return;
        var src = data.html.getElementById(base + '-' + sectionId);
        if (src) {
          dest.innerHTML = src.innerHTML;
          dest.hidden = false;
        } else {
          dest.hidden = true;
        }
      });

      var buyNowBtn = document.querySelector('.pdp-buy-now[data-pdp-buy-now]');
      if (buyNowBtn) {
        var atc = data.html.getElementById('ProductSubmitButton-' + sectionId);
        buyNowBtn.disabled = atc ? atc.hasAttribute('disabled') : true;
      }

      // Loop price (if any) wins over the one-time variant price we just copied.
      syncLoopPrice();
    });
  }

  // Is the Loop subscription widget present on this product? The Loop app block
  // renders an inline script that sets window.LOOP_WIDGET (synchronously, before
  // this deferred script runs), so it's a reliable signal even before Loop has
  // painted its DOM. Products without Loop skip the observer entirely.
  function loopPresent() {
    return !!(
      window.LOOP_WIDGET ||
      document.querySelector('.loop-widget-container') ||
      document.querySelector('[data-loop-widget-purchase-option]')
    );
  }

  // Loop widget: mirror the selected purchase option's price, and re-run on every
  // Loop re-render / selection / frequency change.
  function watchLoop() {
    if (!loopPresent()) return; // Non-Loop product: buttons use the variant price, nothing to watch.

    syncLoopPrice();

    var root = document.querySelector('product-info') || document.body;
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      (window.requestAnimationFrame || window.setTimeout)(function () {
        scheduled = false;
        syncLoopPrice();
      });
    });
    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-checked', 'class'],
    });

    // Frequency dropdown changes fire a change event.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('select[name="selling_plan"]')) {
        syncLoopPrice();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchLoop);
  } else {
    watchLoop();
  }
})();
